import React from "react";
import { Output } from "../../Text";
import { ContentSection, PageWrap, Heading } from "@vwfs-bronson/bronson-react";

class Maintenance extends React.Component {
  render() {
    return (
      <ContentSection>
        <PageWrap>
          <Heading level="2">
            {Output.resolve("pages.maintenance.title")}
          </Heading>
          {Output.resolveAsMarkdown("pages.maintenance.subTitle")}
          {Output.resolveAsMarkdown("pages.maintenance.footerText")}
        </PageWrap>
      </ContentSection>
    );
  }
}

export { Maintenance };
